/**
 * ИСКРЫ СПОСОБНОСТИ над отрядом Гоблинов или Суккубов, который еще может
 * применить способность на этапе способностей
 * (HexGridRenderer.addAbilityAvailableIndicator), — вместо статичной иконки
 * этапа. Три искры стоят так же, как звезды на иконке этапа
 * (img/icons/ability_white.png), и мягко мерцают по очереди: гаснут не до
 * конца, притухая — сжимаются, разгораясь — вырастают. У каждой — белая обводка по силуэту, она мерцает и
 * сжимается вместе с искрой: без нее цветная искра терялась на поле. Под
 * искрами — ровное белесое свечение (мягкий круг эффектов боя,
 * MELEE_TEXTURE_KEYS.GLOW): суммарно искры светят одинаково, поэтому и
 * свечению дышать незачем.
 *
 * Мерцание идет по общему времени сцены: перерисовка поля его не сбивает, и у
 * всех таких отрядов искры мерцают в такт. Отряд, пропустивший ход, искр не
 * показывает — у него отметка сна «zzZ»
 */
export const ABILITY_SPARKLES = Object.freeze({
  // Одна звезда, вырезанная из иконки этапа способностей, — самая крупная:
  // звезда 344 px по центру квадрата 360 px
  textureKey: 'ability_sparkle_white',
  textureStarSizePx: 344,
  // Звезды иконки этапа (513 x 512): центр относительно центра иконки и
  // размер — в пикселях исходной картинки. Порядок — порядок мерцания
  particles: Object.freeze([
    Object.freeze({dx: -85, dy: 61, sizePx: 344}),
    Object.freeze({dx: 86, dy: -127, sizePx: 236}),
    Object.freeze({dx: 157, dy: 145, sizePx: 198}),
  ]),
  // Полный круг мерцания: за него каждая искра разгорается один раз, соседние —
  // через треть круга
  cycleMs: 2300,
  // Самая тусклая точка искры: гаснет не до конца — мерцание спокойное
  minAlpha: 0.35,
  // Размер искры в тусклой и яркой точке — доля ее размера на иконке этапа:
  // притухая, она сжимается, разгораясь — вырастает на столько же
  minScale: 0.85,
  maxScale: 1.15,
  // Белая обводка искры — толщина в пикселях картинки искры. Считается по
  // уменьшенной вдвое копии картинки: мельче на поле она все равно не нужна, а
  // расчет вчетверо дешевле (текстура обводки — один раз на партию)
  outlineKey: 'ability_sparkle_white_outline',
  outlineThicknessPx: 40,
  outlineSourceScale: 0.5,
  // Свечение: поперечник — во столько раз больше иконки этапа
  glowSizeFactor: 1.8,
  glowAlpha: 0.75,
});
